import { Component, OnInit, Input } from '@angular/core';

import { Controllers } from '@shared/core/controllers';

import { Observable } from 'rxjs';
import { ILoyaltyAppTransactionModel, IActivatedOrderVoucherDetails } from '@shared/state';

@Component({
    selector: 'shared-order-full-summary',
    templateUrl: './order-full-summary.shared.component.html',
    styleUrls: ['./order-full-summary.shared.component.scss']
})
export class OrderFullSummaryComponent implements OnInit {
    @Input() public bottomPadding: boolean = false;
    @Input() public maxOnScreenHeight: string = null;
    @Input() public paidWith: string = null;
    @Input() public orderId: number = null;
    @Input() public transactionId: number = null;

    public transactionDetails$: Observable<ILoyaltyAppTransactionModel>;
    public orderItems$: Observable<OLO.Ordering.IOnlineOrderMappedProducts>;
    public orderSummary$: Observable<OLO.Ordering.IOrderSummary>;
    public activeVoucher$: Observable<IActivatedOrderVoucherDetails>;

    constructor(
        public controllers: Controllers,
    ) { }

    ngOnInit(): void {
        if (this.orderId) {
            this.orderItems$ = this.controllers.historyOrders.mappedOrderItems$(this.orderId);
            this.orderSummary$ = this.controllers.historyOrders.getHistoryOrderSummary$(this.orderId);
            this.activeVoucher$ = this.controllers.historyOrders.getHistoryOrderVoucher$(this.orderId);
        }

        if (this.transactionId) {
            this.transactionDetails$ = this.controllers.transactions.getTransaction$(this.transactionId);
            this.orderSummary$ = this.controllers.transactions.getTransactionSummary$(this.transactionId);
        }
    }
}
